import { FC } from 'react'
import ReactSelect from 'react-select'

import {
  CustomStyles,
  inputCustomStyles,
} from 'sections/PromoSection/pages/PromoPage/Sections/PrivacyPolicy/inputCustomStyles'
import { TextPromo } from 'components/ui'
import { useResize } from 'utils/hooks/useResize'

import { privacyPolicy } from './data'

import s from './PrivacyPolicy.module.scss'

export const PrivacyPolicy: FC = () => {
  const { isTablet } = useResize()

  const options = privacyPolicy.sections.map((section, index) => ({
    label: section.title,
    value: `#section-${index}`,
  }))

  const customStyles: CustomStyles = {
    menu: {
      height: '400px',
      position: 'relative',
      top: 0,
      left: 0,
      border: 'none',
      width: '100%',
    },
  }

  const handleSelectChange = (selectedOption: any) => {
    if (selectedOption) {
      document.querySelector(selectedOption.value)?.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <main className={s.privacyPolicy}>
      <h3 className={s.title}>{privacyPolicy.title}</h3>
      {isTablet && (
        <ReactSelect
          options={options}
          onChange={handleSelectChange}
          styles={inputCustomStyles(customStyles)}
          className={s.customSelect}
          components={{ IndicatorSeparator: () => null }}
          defaultValue={options[0]}
        />
      )}
      <section className={s.wrapper}>
        <ul className={s.listWrapper}>
          {privacyPolicy.sections.map((section, index) => (
            <li key={index} className={s.section} id={`section-${index}`}>
              <h4 className={s.subTitle}>{section.title}</h4>
              <ul>
                {section.content.map((content, idx) => (
                  <li key={idx} className={s.content}>
                    <TextPromo size="s16" color="default" fontFamily="ASLHauss">
                      {content.section} {content.text}
                    </TextPromo>
                    {content.subSections && content.subSections.length > 0 && (
                      <ul className={s.subSection}>
                        {content.subSections.map((subSection, subIdx) => (
                          <li key={subIdx} className={s.content}>
                            <TextPromo size="s16" color="default" fontFamily="ASLHauss">
                              {subSection.section} {subSection.text}
                            </TextPromo>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </li>
          ))}
          <TextPromo size="s12" color="gray" fontFamily="ASLHauss" style={{ paddingBottom: '24px' }}>
            &#185; Требования к форме согласия определяются, исходя из требований Закона, включая ст. 5, ст. 9 Закона, и
            по общему правилу утверждаются локальным нормативным актом. При этом согласие может быть получено как на
            материальном (бумажном) носителе, так и в форме электронного документа, подписанного электронной подписью,
            или иным способом, позволяющим подтвердить факт его получения и не противоречащим Закону. Предпочтительным
            способом получения является получение согласия в виде электронного документа
          </TextPromo>
        </ul>
        {!isTablet && (
          <nav className={s.toc}>
            <h4 className={s.subTitle}>Оглавление</h4>
            <ul className={s.list}>
              {privacyPolicy.sections.map((section, index) => (
                <li key={index} className={s.listItem}>
                  <a className={s.link} href={`#section-${index}`}>
                    {section.title}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </section>
    </main>
  )
}
